import { classNames } from 'primereact/utils';
import {
  InputSwitchPassThroughOptions,
  InputSwitchProps,
} from 'primereact/inputswitch';

export const PTInputSwitch: InputSwitchPassThroughOptions = {
  root: ({ props }: { props: InputSwitchProps }) => ({
    className: classNames('inline-block relative', 'w-10 h-6', {
      'opacity-60 select-none pointer-events-none cursor-default':
        props.disabled,
    }),
  }),
  input: {
    className: classNames(
      'absolute appearance-none top-0 left-0 size-full p-0 m-0 opacity-0 z-10 outline-none cursor-pointer',
    ),
  },
  slider: ({ props }: { props: InputSwitchProps }) => ({
    className: classNames(
      'absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent',
      'transition-all duration-200 rounded-2xl',
      'focus:outline-none focus:outline-offset-0 focus:shadow-sm',
      "before:absolute before:content-'' before:top-1/2 before:bg-white before:w-4 before:h-4 before:left-0.5 before:-mt-2 before:rounded-full before:transition-duration-200",
      {
        'bg-gray-500 hover:opacity-5': !props.checked,
        'bg-blue-500 before:transform before:translate-x-4.5': props.checked,
      },
    ),
  }),
};
